import React from 'react';
import {style, classes, vars} from './image-view.st.css';
import {cssAddUnitsToNumericValue, HtmlObjectResizeMode, Values} from '@wix/devzai-utils-common';
import { reactCreateMemo } from "../react-utils/react-utils";

export const ImageViewResizeMode = HtmlObjectResizeMode;

export type ImageViewResizeMode = Values<typeof ImageViewResizeMode>;

export const ImageViewPositionVertical = {
    Top: 'top',
    Center: 'center',
    Bottom: 'bottom',
} as const;

export type ImageViewPositionVertical = Values<typeof ImageViewPositionVertical>;

export const ImageViewPositionHorizontal = {
    Left: 'left',
    Center: 'center',
    Right: 'right',
} as const;

export type ImageViewPositionHorizontal = Values<typeof ImageViewPositionHorizontal>;


export interface ImageViewProps extends React.ImgHTMLAttributes<HTMLImageElement>{
    resizeMode?: ImageViewResizeMode;
    positionVertical?: ImageViewPositionVertical | number;
    positionHorizontal?: ImageViewPositionHorizontal | number;
    imageElementRef?: React.Ref<HTMLImageElement>;
}

export const ImageView = reactCreateMemo(function ImageView(props: ImageViewProps) {

    const {
        resizeMode = ImageViewResizeMode.Contain,
        positionVertical = 'top',
        positionHorizontal = 'center',
        imageElementRef,

        // img HTML attributes default overrides
        decoding = 'async',

        style: cssProps,
        src,
        className,
        ...htmlAttributes

    } = props;



    return (
        <img
            ref={imageElementRef}
            {...htmlAttributes}
            className={style(classes.root, className)}
            style={{
                [vars.objectFit]: resizeMode,
                [vars.objectPositionVertical]: typeof positionVertical === 'number' ?
                    cssAddUnitsToNumericValue(positionVertical, '%') : positionVertical,
                [vars.objectPositionHorizontal]: typeof positionHorizontal === 'number' ?
                    cssAddUnitsToNumericValue(positionHorizontal, '%') : positionHorizontal,
                ...cssProps
            }}
            src={src}
            decoding={decoding}
        />
    )

});

export namespace ImageView {

    export type Props = ImageViewProps;

}